export const formulario = {
  saudacao: 'Olá, {{nome}}',
  abertaAte: 'Aberta até {{fim}}',
  semCampanha: 'Nenhuma campanha aberta no momento.',
  selecione: 'Selecione',
  motivos: {
    SEM_VINCULO:
      'Não encontramos seu cadastro de profissional. Procure a equipe responsável pela campanha.',
    NAO_PARTICIPANTE:
      'Você não está na lista de participantes desta campanha. Procure a equipe responsável pela campanha.',
    PARTICIPANTE_EXCLUIDO: 'Você não faz mais parte desta campanha.',
    CAMPANHA_AGENDADA: 'A campanha começa em {{inicio}}.',
    CAMPANHA_FECHADA: 'A campanha não está aceitando respostas.',
  },
  somenteLeitura: 'Suas respostas não podem mais ser alteradas.',
  brinde: {
    pergunta: 'Você gostaria de receber um brinde da NTConsult de Final de Ano 2026?',
  },
  camiseta: {
    titulo: 'Tamanho da camiseta',
    manterTamanho: 'Manter {{tamanho}}',
    trocar: 'Trocar',
    escolha: 'Qual é o seu tamanho de camiseta?',
    exteriorHint:
      'Para o exterior não enviamos camiseta. O tamanho que você informar atualiza o seu cadastro.',
  },
  entrega: {
    titulo: 'Podemos entregar neste endereço ou você gostaria de receber em outro?',
    aviso:
      'Previsão de entrega: <strong>{{janela}}</strong>. Para o endereço no Brasil indicado por você, por favor, confira com calma se seu endereço está correto. <strong>É necessário que tenha uma pessoa disponível para recebê-lo quando chegar.</strong>',
    avisoDatas:
      'Previsão de entrega: <strong>entre {{inicio}} e {{fim}}</strong>. Para o endereço no Brasil indicado por você, por favor, confira com calma se seu endereço está correto. <strong>É necessário que tenha uma pessoa disponível para recebê-lo quando chegar.</strong>',
    avisoSemJanela:
      'Para o endereço no Brasil indicado por você, por favor, confira com calma se seu endereço está correto. <strong>É necessário que tenha uma pessoa disponível para recebê-lo quando chegar.</strong>',
    cadastro: 'Entregar neste endereço',
    outro: 'Entregar em outro',
    outroTitulo: 'Em qual endereço você gostaria de receber o brinde de Final de Ano 2026?',
    completar: 'Completar o endereço do cadastro',
    separado: 'Separamos o número e o complemento do nome da rua. Confira se está certo.',
    numeroPodeEstarJunto: 'O número pode estar junto do nome da rua. Confira os dois campos.',
    corrigir: 'Não está certo? Corrigir',
    enderecoOriginal: 'No cadastro está assim:',
    exterior: 'Moro no exterior e quero receber no exterior',
    exteriorDescricao:
      'Para o exterior enviamos uma necessaire, sem personalização e sem camiseta.',
    avisoExterior:
      'Para endereços no exterior, enviamos uma <strong>necessaire sem personalização</strong>, comprada em loja local. O prazo varia de país para país. Por favor, confira com calma se seu endereço está correto. <strong>É necessário que tenha uma pessoa disponível para recebê-la quando chegar.</strong>',
    cadastroExterior:
      'O endereço do seu cadastro é fora do Brasil. Para receber o brinde personalizado, informe um endereço no Brasil; ou escolha receber no exterior.',
    exteriorTitulo: 'Em qual endereço no exterior você gostaria de receber?',
    telefoneHint: 'Com o código do país, por exemplo +351 912 345 678. Usado só para a entrega.',
  },
  campos: {
    cep: 'CEP',
    logradouro: 'Logradouro',
    logradouroExemplo: 'Rua, avenida etc',
    numero: 'Número',
    complemento: 'Complemento — opcional',
    complementoExemplo: 'Apartamento, casa, bloco etc',
    bairro: 'Bairro',
    cidade: 'Cidade',
    uf: 'Estado',
    estado: 'Estado',
    pais: 'País',
    enderecoLivre: 'Endereço (rua, número, complemento)',
    endereco: 'Endereço',
    regiao: 'Estado, província ou região — opcional',
    codigoPostal: 'Código postal — opcional',
    telefone: 'Telefone',
    numeroOpcional: 'Número — opcional',
    bairroOpcional: 'Bairro — opcional',
  },
  oficial: {
    titulo: 'Endereço oficial no cadastro',
    cidadeAusente: 'Não encontrou sua cidade? Procure a equipe responsável pela campanha.',
    semCidades: 'Nenhuma cidade encontrada',
    exteriorHint:
      'Fora do Brasil, a cidade e o estado podem não existir no cadastro; nesse caso, a equipe completa depois.',
  },
  cep: {
    buscando: 'Buscando o endereço…',
    preenchido: 'Endereço preenchido pelo CEP. Confira os dados e informe o número.',
    parcial: 'Este CEP atende a cidade toda. Informe a rua e o bairro.',
    naoEncontrado: 'Não encontramos esse CEP. Confira o número ou preencha o endereço manualmente.',
    indisponivel: 'Não foi possível consultar o CEP agora. Preencha o endereço manualmente.',
    cidadeNaoCasou: 'Não achamos a cidade na lista do cadastro. Escolha-a manualmente.',
  },
  confirmar: {
    previsao: 'Previsão de entrega',
    semBrinde: 'Não quero o brinde',
    cadastro: 'Cadastro',
    corrigirCadastro: 'Corrigir o endereço do cadastro',
    alterar: 'Alterar',
    intro:
      'A entrega do brinde está condicionada ao envio do endereço correto e a ter alguém disponível para recebê-lo. Se não tiver certeza, fique à vontade para voltar e conferir.',
    enderecoCorreto: 'Sim, confirmo que meu endereço de entrega está correto.',
    recebedor: 'Sim, haverá alguém disponível para receber a entrega.',
    titulo: 'Confirmação',
  },
  enviar: 'Enviar respostas',
  salvarAlteracoes: 'Salvar alterações',
  validacao: {
    cep: 'Informe um CEP com 8 dígitos.',
    telefone: 'Informe um telefone com o código do país, de 8 a 15 dígitos.',
    tamanho: 'Use no máximo {{max}} caracteres.',
    obrigatorio: 'Obrigatório.',
  },
  resumo: {
    tamanho: 'Tamanho da camiseta',
    entrega: 'Endereço de entrega',
    oficialSem: 'Sem alteração',
    entregaExterior: 'Entrega no exterior (necessaire)',
  },
  axiis: {
    camiseta: { sucesso: 'Tamanho da camiseta atualizado no seu cadastro.' },
    endereco: { sucesso: 'Endereço oficial atualizado no seu cadastro.' },
    pendente:
      'Suas respostas estão salvas. A atualização do seu cadastro ainda não foi concluída; a equipe vai concluí-la. Você não precisa enviar de novo.',
  },
  passos: {
    progresso: 'Passo {{atual}} de {{total}}',
    continuar: 'Continuar',
    voltar: 'Voltar',
  },
  mesmo: {
    pergunta:
      'Podemos considerar este como sendo seu novo endereço e atualizá-lo em nossos sistemas?',
    sim: 'Sim, este é meu novo endereço e gostaria de atualizar',
    nao: 'Não, este é apenas o endereço onde quero receber o brinde',
  },
  cadastro: {
    titulo: 'Endereço do seu cadastro',
    certo: 'Está certo',
    corrigir: 'Corrigir',
    pular: 'Pular',
  },
  respondido: {
    selo: 'Respondido',
    quando: 'Enviado em {{quando}}',
    alterar: 'Alterar respostas',
  },
  link: {
    titulo: 'Link da campanha',
    copiar: 'Copiar link',
  },
} as const;
